import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new2",
  "use": "new2-usage",
  "viewBox": "0 0 26.62 26.62",
  "content": "<symbol viewBox=\"0 0 26.62 26.62\" id=\"new2\"><path d=\"M25.79 10h-9.15V.83a.83.83 0 0 0-.83-.83h-5a.84.84 0 0 0-.81.83V10H.83a.84.84 0 0 0-.83.84v5a.83.83 0 0 0 .83.83H10v9.15a.84.84 0 0 0 .84.83h5a.83.83 0 0 0 .83-.83v-9.18h9.15a.83.83 0 0 0 .83-.83v-5a.84.84 0 0 0-.86-.81z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/new2.svg
// module id = Kiwr
// module chunks = 1